import { useCallback } from "react";

import BusinessOutlined from "@mui/icons-material/BusinessOutlined";
import OpenInNewRounded from "@mui/icons-material/OpenInNewRounded";

import ResizeableSidebar from "../../../components/sidebar/ResizeableSidebar";
import { PanelIconButton } from "../../../components/sidebar/shared/panelChrome";
import { CorrespondentDetailPanel } from "../../CorrespondentsScreen/pages/Drilldown";

/**
 * LoanCorrespondentSidebar — slide-in panel for the loan's correspondent,
 * opened from the drilldown overview's "Correspondent" field.
 *
 * It embeds the SAME `CorrespondentDetailPanel` the full Correspondents
 * drilldown (`/correspondents/{id}`) renders — identical tabs (Profile,
 * Contacts, Coverage, Pricing, Overlays, Users, Loans) and content — so there's
 * a single source of truth: changes to the drilldown automatically show here.
 * A header button opens the full drilldown in a new tab.
 */
const LoanCorrespondentSidebar = ({ correspondentId, open, onClose }) => {
  const openInNewTab = useCallback(() => {
    if (!correspondentId) return;
    window.open(
      `/correspondents/${correspondentId}`,
      "_blank",
      "noopener,noreferrer",
    );
  }, [correspondentId]);

  if (!open) return null;

  return (
    <ResizeableSidebar
      open={open}
      onClose={onClose}
      title="Correspondent"
      titleIcon={<BusinessOutlined />}
      // Opens at the shared panel width (panelChrome.PANEL_DEFAULT_WIDTH).
      bodyPadding={0}
      closeButtonStartContent={
        <PanelIconButton
          title="Open correspondent in new tab"
          icon={OpenInNewRounded}
          onClick={openInNewTab}
          disabled={!correspondentId}
        />
      }
    >
      {correspondentId ? (
        <CorrespondentDetailPanel id={correspondentId} />
      ) : null}
    </ResizeableSidebar>
  );
};

export default LoanCorrespondentSidebar;
